import Skeleton from 'react-loading-skeleton';
import { v4 as uuid } from 'uuid';

import styles from './FiltersSkeleton.module.scss';

const filterSkeletons = Array.from({ length: 5 }, () => uuid()).map((key) => (
  <Skeleton containerClassName={styles.filterSkeleton} key={key} />
));

const FiltersSkeleton = () => {
  return (
    <div className={styles.root}>
      <div className={styles.priceSkeleton}>
        <Skeleton containerClassName={styles.priceHeadSkeleton} />
        <div className={styles.priceRangeInputWr}>
          <Skeleton containerClassName={styles.priceInputSkeleton} />
          <Skeleton containerClassName={styles.priceInputSkeleton} />
        </div>
      </div>

      {filterSkeletons}
    </div>
  );
};

export default FiltersSkeleton;
